"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function focusOnElement(elementId) {
  var elementToFocus = document.getElementById(elementId);
  if (elementToFocus) {
    elementToFocus.focus();
  }
}
var _default = focusOnElement;
exports["default"] = _default;